import "../scss/style.scss";

// Importing image
//const img = new URL("RELATIVE_PATH", import.meta.url).href;

// JS Scripts
import "./scripts/_navbar.js";
import "./scripts/_burger.js";
import "./scripts/_scrolldirection.js";
import "./scripts/_splide.js";
import "./scripts/_accordion.js";
import "./scripts/_archive.js";
import "./scripts/_contact.js";
import "./scripts/_wow.js";
import "./scripts/_feed.js";
import "./scripts/_modal.js";
import "./scripts/_newsletter.js";
import "./scripts/_back.js";
import "./scripts/_recipe-video.js";

document.addEventListener("DOMContentLoaded", function () {

});
